
const createStatObject = (id, statPrefix,bodylist,data,TotalCnt)  => ({
    FIDELITY_ID: id,
    FIDELITY_NAME: Object.values(bodylist).filter(content => id === content.FIDELITY_CODE)[0].FIDELITY_NAME,
    NATIONAL_NORMAL: isNaN(((data.statInfo[`${statPrefix}_NORMAL_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2)) === true ? '0.00' : ((data.statInfo[`${statPrefix}_NORMAL_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2),
    ORG_NORMAL: isNaN(((data.statInfo[`${statPrefix}_NORMAL_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2)) === true? '0.00' : ((data.statInfo[`${statPrefix}_NORMAL_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2),
    ORG_UNKNOWN: isNaN(((data.statInfo[`${statPrefix}_UNKNOWN_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2)) === true? '0.00' : ((data.statInfo[`${statPrefix}_UNKNOWN_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2),
    ORG_BLANK: isNaN(((data.statInfo[`${statPrefix}_BLANK_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2)) === true? '0.00' : ((data.statInfo[`${statPrefix}_BLANK_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2),
    ORG_REVIEW: isNaN(((data.statInfo[`${statPrefix}_REVIEW_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2)) === true? '0.00' : ((data.statInfo[`${statPrefix}_REVIEW_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2),
    ORG_ERROR: isNaN(((data.statInfo[`${statPrefix}_ERROR_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2)) === true? '0.00' : ((data.statInfo[`${statPrefix}_ERROR_CNT`] / data.statInfo[`${TotalCnt}`]) * 100 ).toFixed(2), 
    TOTAL_CNT: TotalCnt
});

const generate_fidelity_list = (bodylist,data,searchType) => {

    let datalist = [];

    datalist.push(createStatObject('PTMIBRTD','AGE',bodylist,data,'TOTAL_CNT1'));
    datalist.push(createStatObject('PTMISEXX','SEX',bodylist,data,'TOTAL_CNT1'));
    datalist.push(createStatObject('PTMIZIPC','ZIP',bodylist,data,'TOTAL_CNT1'));
    datalist.push(createStatObject('PTMIIUKD','IUKD',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIHSCD','HSCD',bodylist,data,'TOTAL_CNT1'));

    datalist.push(createStatObject('PTMIINDTM','INDT',bodylist,data,'TOTAL_CNT1'));
    datalist.push(createStatObject('PTMIAKDTM','AKDT',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIDGKD','DGKD',bodylist,data,'TOTAL_CNT1'));
    datalist.push(createStatObject('PTMIARCF','ARCF',bodylist,data,'TOTAL_CNT3'));

    if(searchType !== '02') {
        datalist.push(createStatObject('PTMIARCS','ARCS',bodylist,data,'TOTAL_CNT3'));
        datalist.push(createStatObject('PTMITAIP','TAIP',bodylist,data,'TOTAL_CNT4'));
        datalist.push(createStatObject('PTMIEQUI','EQUI',bodylist,data,'TOTAL_CNT4'));
    }
    datalist.push(createStatObject('PTMIINRT','INRT',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIINTP','INTP',bodylist,data,'TOTAL_CNT13'));
    datalist.push(createStatObject('PTMIINCD','INCD',bodylist,data,'TOTAL_CNT13'));

    datalist.push(createStatObject('PTMIINMN','INMN',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIEMSY','EMSY',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIRESP','RESP',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIHIBP','HIBP',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMILOBP','LOBP',bodylist,data,'TOTAL_CNT11'));

    datalist.push(createStatObject('PTMIPULS','PULS',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIBRTH','BRTH',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIBDHT','BDHT',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIVOXS','VOXS',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIKPR1','KPR1',bodylist,data,'TOTAL_CNT9'));

    datalist.push(createStatObject('PTMIKTS1','KTS1',bodylist,data,'TOTAL_CNT18'));
    datalist.push(createStatObject('PTMIKTDTM','KTDT',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIKJOB','KJOB',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIKIDN','KIDN',bodylist,data,'TOTAL_CNT11'));
    if(searchType !== '02') {
        datalist.push(createStatObject('PTMIAREA','AREA',bodylist,data,'TOTAL_CNT11'));
        datalist.push(createStatObject('PTMIMDCD','AREA',bodylist,data,'TOTAL_CNT12'));
        datalist.push(createStatObject('PTMISDCD','AREA',bodylist,data,'TOTAL_CNT12'));
    }
    datalist.push(createStatObject('SDMDDEPT','SDMDDEPT',bodylist,data,'TOTAL_CNT12'));
    datalist.push(createStatObject('SDMDDIVI','SDMDDIVI',bodylist,data,'TOTAL_CNT12'));
    datalist.push(createStatObject('SDMDDRLC','SDMDDRLC',bodylist,data,'TOTAL_CNT12'));
    datalist.push(createStatObject('SDMDSDDTM','SDMDSDDT',bodylist,data,'TOTAL_CNT12'));

    datalist.push(createStatObject('PTMIEMRT','EMRT',bodylist,data,'TOTAL_CNT11'));
    if(searchType !== '02') {
        datalist.push(createStatObject('PTMIHSRT','HSRT',bodylist,data,'TOTAL_CNT17'));
    }
    datalist.push(createStatObject('PTMIDCTP','DCTP',bodylist,data,'TOTAL_CNT14'));
    datalist.push(createStatObject('PTMIDCCD','DCCD',bodylist,data,'TOTAL_CNT14'));
    if(searchType !== '02') {
        datalist.push(createStatObject('PTMIDEPT','DEPT',bodylist,data,'TOTAL_CNT2'));
    }

    datalist.push(createStatObject('PTMIOTDTM','OTDT',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('DGOTDIAG','DGOT',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('DGOTDGGB','OTGB',bodylist,data,'TOTAL_CNT11'));
    datalist.push(createStatObject('PTMIDCRT','DCRT',bodylist,data,'TOTAL_CNT15'));
    datalist.push(createStatObject('PTMIDCTP2','DCTP2',bodylist,data,'TOTAL_CNT16'));

    datalist.push(createStatObject('PTMIDCCD2','DCCD2',bodylist,data,'TOTAL_CNT16'));
    datalist.push(createStatObject('PTMIDCDTM','DCDT',bodylist,data,'TOTAL_CNT15'));
    datalist.push(createStatObject('DGDCDIAG','DGDC',bodylist,data,'TOTAL_CNT15'));
    datalist.push(createStatObject('DGDCDGGB','DCGB',bodylist,data,'TOTAL_CNT15'));
    if(searchType !== '02') {
        datalist.push(createStatObject('PTMIHSDTM','HSDT',bodylist,data,'TOTAL_CNT19'));
    }
    return datalist

}
export default generate_fidelity_list;